import { render, staticRenderFns } from "./VehicleAssignmentDialog.vue?vue&type=template&id=120cd900&"
import script from "./VehicleAssignmentDialog.vue?vue&type=script&lang=ts&"
export * from "./VehicleAssignmentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports